import PobName from '../pob-name';
import { Avatar, Card, Checkbox } from 'antd';
import defaultAvatarImg from 'img/default-avatar.png';
import { DraggableProvided } from 'react-beautiful-dnd';
import { buildPobProfImgUrl } from '../../util';
import { useContext } from 'react';
import { QMCurrentStateCtx } from 'components/quartermaster/state';
import PobDestination from '../pob-destination';

export interface DepartingPobListItemProps extends React.HTMLAttributes<HTMLDivElement> {
	pobObj: any; // AppSync PobNode,
	provided: DraggableProvided;
	selectionEnabled?: boolean;
	selected?: boolean;
	onSelectedChange?: () => void;
}

const DepartingPobListItem: React.FC<DepartingPobListItemProps> = (props) => {
	const { pobObj, provided, selectionEnabled, selected, onSelectedChange, ...rest } = props;

	const qmCurrentState = useContext(QMCurrentStateCtx);

	const avatar = (
		<Avatar
			icon={<img onError={() => null} src={defaultAvatarImg} alt='' />}
			src={buildPobProfImgUrl(pobObj)}
		/>
	);
	const title = <PobName pob={pobObj} />;
	// const description = pobObj.currentJobTitle || 'Rig Engineer';

	return (
		<div
			{...rest}
			ref={provided.innerRef}
			{...provided.draggableProps}
			// Drag-and-drop feature is temporarily disabled.
			// {...provided.dragHandleProps}
			style={{
				...props.style,
				...provided.draggableProps.style,
			}}
			onDoubleClick={() => qmCurrentState.setEditPobDrawerOpen(true, pobObj._id)}
		>
			<Card
				bodyStyle={{
					padding: 6,
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						width: '100%',
					}}
				>
					{selectionEnabled ? (
						<Checkbox
							className='mc-qm-pob-select'
							aria-label={`Select ${pobObj.lastName}, ${pobObj.firstName}`}
							checked={selected}
							onClick={(event) => event.stopPropagation()}
							onChange={onSelectedChange}
						/>
					) : null}
					<div style={{ marginRight: '1rem' }}>{avatar}</div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<h4 style={{ marginBottom: 0 }}>{title}</h4>
						{/* <div>{description}</div> */}
					</div>
					<PobDestination pobObj={pobObj} showDepartingIcon />
				</div>
			</Card>
		</div>
	);
};

export default DepartingPobListItem;
